import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import helpers from 'src/styles/helpers';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  header: {
    display: 'flex',
    justifyContent: ' space-between',
    '& .MuiPaper-root': {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between'
    }
  },
  searchSection: {
    width: '420px',
    padding: '20px 20px'
  },
  searchSectionInput: {
    '& .MuiInputBase-root': {
      minHeight: '48px'
    }
  },
  pageWrapper: {
    paddingTop: '32px'
  },
  platformFee: {
    display: 'flex',
    alignItems: 'center',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  },
  section: {
    padding: '24px 32px',
    background: palette.brandGradients.fade,
    borderRadius: '2px 2px 0 0',
    border: "1px solid ".concat(palette.shades[300]),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '32px',
    '& + $subSection': {
      borderTop: 'none'
    }
  },
  singleSection: {
    borderRadius: '2px',
    [breakpointsFunc.breakpoints.down('md')]: {
      alignItems: 'flex-start'
    }
  },
  subSection: {
    padding: '24px 32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: "1px solid ".concat(palette.shades[300]),
    '& + &': {
      borderTop: 'none'
    },
    '&:last-child': {
      borderRadius: '0 0 2px 2px'
    }
  },
  couponSection: {
    borderTop: 'none'
  },
  tabletSubsection: {
    [breakpointsFunc.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  promocode: {
    [breakpointsFunc.breakpoints.down('md')]: {
      marginBottom: '18px'
    }
  },
  paymentDescription: {
    marginRight: '24px'
  },
  paymentPaper: {
    marginTop: '40px !important'
  },
  codeFieldWrapper: {
    display: 'flex',
    alignItems: 'center',
    [breakpointsFunc.breakpoints.down('md')]: {
      marginTop: '24px'
    }
  },
  codeField: {
    width: '240px',
    marginRight: '10px'
  },
  cancelSubscriptionContainer: {
    marginTop: '40px',
    paddingTop: '40px',
    borderTop: "1px solid ".concat(palette.shades[400])
  },
  cancelSubscription: {
    padding: '24px 32px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .MuiButton-actionButton': {
      border: "1px solid ".concat(palette.shades[300]),
      flexShrink: '0',
      marginLeft: '24px'
    }
  },
  optionsPaper: {
    marginTop: '0 !important',
    zIndex: '5'
  },
  accordion: {
    boxShadow: 'none',
    marginTop: '0 !important',
    '& + &': {
      borderTop: "1px solid ".concat(palette.shades[300]),
      marginTop: '0'
    },
    '&.Mui-expanded': {
      margin: '0'
    }
  },
  accordionSummary: {
    padding: '24px 40px',
    '& .MuiAccordionSummary-content': {
      display: 'flex',
      alignItems: 'center'
    },
    '& .MuiAccordionSummary-expandIconWrapper path': {
      fill: palette.shades[700]
    }
  },
  counter: {
    width: '46px',
    height: '50px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    '&:before': {
      content: '""',
      width: '0',
      height: '0',
      borderLeft: "8px solid transparent",
      borderRight: "8px solid transparent",
      borderBottom: "8px solid ".concat(palette.shades[700])
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      flexShrink: '0',
      marginLeft: '24px'
    }
  },
  option: {
    flexGrow: '1'
  },
  accordionDetails: {
    padding: '24px 40px',
    borderTop: "1px solid ".concat(palette.shades[300])
  }
}));
export default useStyles;